import script from "./review-index.vue?vue&type=script&setup=true&lang=js"
export * from "./review-index.vue?vue&type=script&setup=true&lang=js"

import "./review-index.vue?vue&type=style&index=0&id=d75fbd86&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d75fbd86"]])

export default __exports__